import { Component, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ScheduleComponent } from '../schedule/schedule.component';
import { Filter } from '../../interfaces/filter';
import { ActivatedRoute } from '@angular/router';
import { Schedule } from '../../interfaces/schedule';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';
import { environment } from 'src/environments/environment';
import { DataService } from '../../services/data.service';
import { add, format, sub } from 'date-fns';
import { FilterItemComponent } from '../filter-item/filter-item.component';
import { DOCUMENT } from '@angular/common';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';
import { Subscription } from 'rxjs';
import { FiltersColorHelper } from 'src/app/utils/helpers/filtersColorHelper';
import { LocalizationService } from '../../services/localization.service';
import { ButtonStateService } from '../../services/button-state.service';

@Component({
  selector: 'app-day-schedule',
  templateUrl: './day-schedule.component.html',
  styleUrls: [
    './day-schedule.component.scss',
    './day-schedule.component.en.scss',
  ],
})
export class DayScheduleComponent extends ScheduleComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;

  private filtersInited: boolean = false;
  private _currentDate: Date = new Date();
  @Input()
  get currentDate(): Date {
    return this._currentDate;
  }
  set currentDate(date: Date) {
    this._currentDate = date;
    if (this.filtersInited) this.getScheduleData();
  }
  private dataServiceSubscription: Subscription | null = null;

  typeFilterItems: Filter[] = [
    {
      value: 'assignments',
      valueArr: [StudentDataType.Assignment],
      label: 'בחינות',
      color: FiltersColorHelper.defaultColorsList.assignments.primary,
      checked: true,
    },
    {
      value: 'exams and quizzes',
      valueArr: [StudentDataType.Exam, StudentDataType.Quiz],
      label: 'בחנים ומטלות',
      color: FiltersColorHelper.defaultColorsList.exams.primary,
      checked: true,
    },
    {
      value: 'lessons',
      valueArr: [StudentDataType.Lesson],
      label: 'שיעורים',
      color: FiltersColorHelper.defaultColorsList.lessons.primary,
      checked: true,
    },
    {
      value: 'academic events',
      valueArr: [StudentDataType.Event],
      label: 'אירועים אקדמיים',
      color: FiltersColorHelper.defaultColorsList.academicEvents.primary,
      checked: true,
    },
  ];

  override schedule: Schedule[] = [{ ranges: [] }];

  StudentDataType = StudentDataType;
  selectedCalendarTypes: StudentDataType[] = [
    StudentDataType.Exam,
    StudentDataType.Quiz,
    StudentDataType.Assignment,
    StudentDataType.Event,
    StudentDataType.Lesson,
  ];

  FiltersColorHelper = FiltersColorHelper;

  isServerError: boolean = false;

  @ViewChild('typeFilter') typeFilterComponent!: FilterItemComponent;

  constructor(
    private route: ActivatedRoute,
    dataService: DataService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    userAgentService: UserAgentService,
    buttonStateService: ButtonStateService
  ) {
    super(dataService, userAgentService,buttonStateService);
  }

  override ngOnInit() {
    if (this.widgetData.timeRange && this.widgetData.timeRange.length) {
      this.timeRange = this.widgetData.timeRange;
    }
    this.initSelectedFilters();
    this.getScheduleData();
  }

  private initSelectedFilters() {
    if (this.widgetData.studentCalendarFilters) {
      this.typeFilterItems = FiltersColorHelper.convertToFilterArr(
        this.widgetData.studentCalendarFilters
      );
      this.selectedCalendarTypes =
        FiltersColorHelper.convertStudentDataTypeToArr().filter((item) =>
          FiltersColorHelper.convertToCheckboxEnumArr(
            this.typeFilterItems
          ).includes(item)
        );
    }
    this.filtersInited = true;
  }

  getScheduleData() {
    this.isLoading = true;
    let url =
      environment.apiUrl +
      '/Portal/StudentExamsAndTasksListViewBlockList/GetExamsAndTasksForScheduleWidget';
    //let rangeDates = this.getDisplayRangeDate();
    let rangeDates = this.getDisplayDate();
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      dataTypes: this.selectedCalendarTypes!,
      fromDate: add(rangeDates, { hours: this.timeRange[0] }),
      toDate: add(rangeDates, {
        hours: this.timeRange[this.timeRange.length - 1],
      }),
      term: null,
    };

    // Cancel the previous subscription (if any)
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }

    this.dataServiceSubscription = this.dataService
      .getDataByToken(url, request)
      .subscribe({
        next: (responseData) => {
          if (
            responseData &&
            responseData.ranges &&
            responseData.ranges.length
          ) {
            for (let i = 0; i < responseData.ranges.length; i++) {
              let rangeSlot = responseData.ranges[i];
              if (rangeSlot.slots && Array.isArray(rangeSlot.slots)) {
                for (let j = 0; j < rangeSlot.slots.length; j++) {
                  let slot = rangeSlot.slots[j];
                  if (slot.lessons && Array.isArray(slot.lessons)) {
                    for (let k = 0; k < slot.lessons.length; k++) {
                      let lesson = slot.lessons[k];
                      lesson.color = FiltersColorHelper.getPrimaryColor(
                        lesson.eventType,
                        this.widgetData.studentCalendarFilters
                      );
                    }
                  }
                }
              }
            }

            this.schedule = [responseData];
          } else {
            this.schedule = [{ ranges: [] }];
          }
          this.isLoading = false;
        },
        error: (e: any) => {
          console.error(e);
          this.isLoading = false;
          this.isServerError = true;
        },
      });
  }

  // getDisplayRangeDate(): [Date, Date] {
  //   var timezoneOffset = this.currentDate.getTimezoneOffset();
  //   return [add(this.currentDate, { minutes: -timezoneOffset }), add(this.currentDate, { days: 1, minutes: -timezoneOffset })];
  // }

  getDisplayDate(): Date {
    var timezoneOffset = this.currentDate.getTimezoneOffset();
    let date = this.currentDate;
    date.setHours(0, 0, 0, 0);
    date = add(date, { minutes: -timezoneOffset });
    return date;
  }

  getCurrentDateForDisplay(): string {
    return format(this.currentDate, 'EEEE, dd MMMM yyyy', {
      locale: LocalizationService.getCurrentLocale(),
    });
  }

  dayChange(direction: string) {
    if (direction == 'next') {
      this.currentDate = add(this.currentDate, { days: 1 });
    } else if (direction == 'prev') {
      this.currentDate = sub(this.currentDate, { days: 1 });
    }
  }

  btnTodayClick() {
    this.currentDate = new Date();
  }

  typeFilterChange(event: any, value: string, types?: any[]) {
    let index = this.typeFilterItems.findIndex((c) => c.value == value);
    this.typeFilterItems[index].checked = event.checked;

    let checkboxEnums = types!
      .map(Number)
      .filter((val: number) =>
        Object.values(StudentDataType).includes(val)
      ) as StudentDataType[];
    if (event.checked) {
      this.selectedCalendarTypes.push(...checkboxEnums);
    } else {
      this.selectedCalendarTypes = this.selectedCalendarTypes.filter(
        (item) => !checkboxEnums.includes(item)
      );
    }

    this.typeFilterComponent.initValue();
    this.getScheduleData();
  }

  mobileTypeFilterChange(filters: Filter[]) {
    this.typeFilterItems = filters;
    let checkboxEnums = filters
      .filter((c) => c.checked)
      .reduce<StudentDataType[]>(
        (acc, filter) => [...acc, ...filter.valueArr!],
        []
      );
    let enumToArray: StudentDataType[] = Object.keys(StudentDataType)
      .filter((key) => isNaN(Number(key)))
      .map(
        (key) => StudentDataType[key as any]
      ) as unknown as StudentDataType[];
    this.selectedCalendarTypes = enumToArray.filter((item) =>
      checkboxEnums.includes(item)
    );
    this.getScheduleData();
  }

  closeOpenMobileFilter(state: boolean) {
    let mainMobileContainer = this.document.querySelector(
      'app-widget-grid-card.mobile-modal .card-component-wrap'
    );
    if (mainMobileContainer) {
      if (state) {
        this.renderer.setStyle(mainMobileContainer, 'z-index', '0');
      } else {
        this.renderer.removeStyle(mainMobileContainer, 'z-index');
      }
    }
  }
}